export default {
    "title": "My profile",
    "adminDescription": "Connected with the user <0>{{email}}</0>",
    "clientDescription": "Connected with the user <0>{{email}}</0> associated with the company <0>{{client}}</0>",
    "inputs": {
        "name": "Name *",
        "surnames": "Surnames",
        "email": "Email *",
        "lang": "Interface languages",
        "ref": "Reference period (start)",
        "currentPassword": "Current password *",
        "newPassword": "New password *",
        "verifyNewPassword": "Re-enter password *"
    },
    "requirements": {
        "title": "Minimum requirements for the new password:",
        "characters": "At least 6 characters",
        "lower": "A lowercase letter",
        "upper": "A uppercase letter",
        "number": "A numeric digit",
        "special": "A special character"
    },
    "lastAccess": "Last accesses made",
    "date": "Date and time",
    "action": {
        "save": "Save",
        "changePassword": "Change password"
    },
    "langOptions": {
        "es": "Spanish",
        "en": "English"
    },
    "refOptions": {
        "currentYear": "This year",
        "lastYear": "Last year"
    },
    "validations": {
        "currentPassword": "The current password is required",
        "password": "Not all requirements are met",
        "verifyPassword": "Passwords do not match"
    },
    "toaster": {
        "success": {
            "updateUser": "User modified successfully",
            "updateUserPassword": "Password updated successfully"
        },
        "error": {
            "updateUserPassword": "The current password is not correct"
        }
    }
}